import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { F as FOCUS_TYPE } from './common.js';
import { c as convertMBToBytes, g as getExtension, E as EXTENSION_TO_TYPE, m as modifyPropertiesOnFile, a as getBaseName, r as renameFile, b as getExtensionsList, d as defineCustomElement$k } from './wpp-file-upload-item2.js';
import { d as defineCustomElement$j } from './wpp-icon-cross2.js';
import { d as defineCustomElement$i } from './wpp-icon-database2.js';
import { d as defineCustomElement$h } from './wpp-icon-document2.js';
import { d as defineCustomElement$g } from './wpp-icon-error2.js';
import { d as defineCustomElement$f } from './wpp-icon-file2.js';
import { d as defineCustomElement$e } from './wpp-icon-file-zip2.js';
import { d as defineCustomElement$d } from './wpp-icon-image2.js';
import { d as defineCustomElement$c } from './wpp-icon-info2.js';
import { d as defineCustomElement$b } from './wpp-icon-music2.js';
import { d as defineCustomElement$a } from './wpp-icon-pitch2.js';
import { d as defineCustomElement$9 } from './wpp-icon-spreadsheet2.js';
import { d as defineCustomElement$8 } from './wpp-icon-success2.js';
import { d as defineCustomElement$7 } from './wpp-icon-video-clip2.js';
import { d as defineCustomElement$6 } from './wpp-icon-warning2.js';
import { d as defineCustomElement$5 } from './wpp-inline-message2.js';
import { d as defineCustomElement$4 } from './wpp-internal-tooltip2.js';
import { d as defineCustomElement$3 } from './wpp-spinner2.js';
import { d as defineCustomElement$2 } from './wpp-tooltip2.js';

var ScrollState;
(function (ScrollState) {
  ScrollState["scroll"] = "scroll";
})(ScrollState || (ScrollState = {}));

const wppFileUploadCss = ".typography-5xl-display{font-size:var(--wpp-typography-5xl-display-font-size, 48px);font-family:var(--wpp-typography-5xl-display-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-5xl-display-line-height, 62px);letter-spacing:var(--wpp-typography-5xl-display-letter-spacing, 0);text-transform:var(--wpp-typography-5xl-display-text-transform, initial);color:var(--wpp-typography-5xl-display-color, var(--wpp-text-color));font-weight:var(--wpp-typography-5xl-display-font-weight, 600);font-style:var(--wpp-typography-5xl-display-font-style, normal)}.typography-4xl-display{font-size:var(--wpp-typography-4xl-display-font-size, 36px);font-family:var(--wpp-typography-4xl-display-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-4xl-display-line-height, 48px);letter-spacing:var(--wpp-typography-4xl-display-letter-spacing, 0);text-transform:var(--wpp-typography-4xl-display-text-transform, initial);color:var(--wpp-typography-4xl-display-color, var(--wpp-text-color));font-weight:var(--wpp-typography-4xl-display-font-weight, 600);font-style:var(--wpp-typography-4xl-display-font-style, normal)}.typography-3xl-heading{font-size:var(--wpp-typography-3xl-heading-font-size, 28px);font-family:var(--wpp-typography-3xl-heading-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-3xl-heading-line-height, 40px);letter-spacing:var(--wpp-typography-3xl-heading-letter-spacing, 0);text-transform:var(--wpp-typography-3xl-heading-text-transform, initial);color:var(--wpp-typography-3xl-heading-color, var(--wpp-text-color));font-weight:var(--wpp-typography-3xl-heading-font-weight, 600);font-style:var(--wpp-typography-3xl-heading-font-style, normal)}.typography-2xl-heading{font-size:var(--wpp-typography-2xl-heading-font-size, 24px);font-family:var(--wpp-typography-2xl-heading-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-2xl-heading-line-height, 32px);letter-spacing:var(--wpp-typography-2xl-heading-letter-spacing, 0);text-transform:var(--wpp-typography-2xl-heading-text-transform, initial);color:var(--wpp-typography-2xl-heading-color, var(--wpp-text-color));font-weight:var(--wpp-typography-2xl-heading-font-weight, 600);font-style:var(--wpp-typography-2xl-heading-font-style, normal)}.typography-xl-heading{font-size:var(--wpp-typography-xl-heading-font-size, 20px);font-family:var(--wpp-typography-xl-heading-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xl-heading-line-height, 32px);letter-spacing:var(--wpp-typography-xl-heading-letter-spacing, 0);text-transform:var(--wpp-typography-xl-heading-text-transform, initial);color:var(--wpp-typography-xl-heading-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xl-heading-font-weight, 600);font-style:var(--wpp-typography-xl-heading-font-style, normal)}.typography-l-strong{font-size:var(--wpp-typography-l-body-font-size, 18px);font-family:var(--wpp-typography-l-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-l-body-line-height, 28px);letter-spacing:var(--wpp-typography-l-body-letter-spacing, 0);text-transform:var(--wpp-typography-l-body-text-transform, initial);color:var(--wpp-typography-l-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-l-strong-font-weight, 600);font-style:var(--wpp-typography-l-strong-font-style, normal)}.typography-l-midi{font-size:var(--wpp-typography-l-body-font-size, 18px);font-family:var(--wpp-typography-l-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-l-body-line-height, 28px);letter-spacing:var(--wpp-typography-l-body-letter-spacing, 0);text-transform:var(--wpp-typography-l-body-text-transform, initial);color:var(--wpp-typography-l-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-l-midi-font-weight, 500);font-style:var(--wpp-typography-l-midi-font-style, normal)}.typography-l-body{font-size:var(--wpp-typography-l-body-font-size, 18px);font-family:var(--wpp-typography-l-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-l-body-line-height, 28px);letter-spacing:var(--wpp-typography-l-body-letter-spacing, 0);text-transform:var(--wpp-typography-l-body-text-transform, initial);color:var(--wpp-typography-l-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-l-body-font-weight, 400);font-style:var(--wpp-typography-l-body-font-style, normal)}.typography-m-strong{font-size:var(--wpp-typography-m-body-font-size, 16px);font-family:var(--wpp-typography-m-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-m-body-line-height, 24px);letter-spacing:var(--wpp-typography-m-body-letter-spacing, 0);text-transform:var(--wpp-typography-m-body-text-transform, initial);color:var(--wpp-typography-m-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-m-strong-font-weight, 600);font-style:var(--wpp-typography-m-strong-font-style, normal)}.typography-m-midi{font-size:var(--wpp-typography-m-body-font-size, 16px);font-family:var(--wpp-typography-m-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-m-body-line-height, 24px);letter-spacing:var(--wpp-typography-m-body-letter-spacing, 0);text-transform:var(--wpp-typography-m-body-text-transform, initial);color:var(--wpp-typography-m-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-m-midi-font-weight, 500);font-style:var(--wpp-typography-m-midi-font-style, normal)}.typography-m-body{font-size:var(--wpp-typography-m-body-font-size, 16px);font-family:var(--wpp-typography-m-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-m-body-line-height, 24px);letter-spacing:var(--wpp-typography-m-body-letter-spacing, 0);text-transform:var(--wpp-typography-m-body-text-transform, initial);color:var(--wpp-typography-m-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-m-body-font-weight, 400);font-style:var(--wpp-typography-m-body-font-style, normal)}.typography-s-strong{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-strong-font-weight, 600);font-style:var(--wpp-typography-s-strong-font-style, normal)}.typography-s-midi{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-midi-font-weight, 500);font-style:var(--wpp-typography-s-midi-font-style, normal)}.typography-s-body{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal)}.typography-xs-strong{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-strong-font-weight, 600);font-style:var(--wpp-typography-xs-strong-font-style, normal)}.typography-xs-midi{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-midi-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-midi-font-weight, 500);font-style:var(--wpp-typography-xs-midi-font-style, normal)}.typography-xs-body{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-body-font-weight, 400);font-style:var(--wpp-typography-xs-body-font-style, normal)}.typography-2xs-strong{font-size:var(--wpp-typography-2xs-strong-font-size, 10px);font-family:var(--wpp-typography-2xs-strong-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-2xs-strong-line-height, 20px);letter-spacing:var(--wpp-typography-2xs-strong-letter-spacing, 0.5px);text-transform:var(--wpp-typography-2xs-strong-text-transform, uppercase);color:var(--wpp-typography-2xs-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-2xs-strong-font-weight, 700);font-style:var(--wpp-typography-2xs-strong-font-style, normal)}:host{--fu-width:var(--wpp-file-upload-width, 100%);--fu-height:var(--wpp-file-upload-height, 148px);--fu-bg-color:var(--wpp-file-upload-bg-color, var(--wpp-grey-color-000));--fu-bg-color-hover:var(--wpp-file-upload-bg-color-hover, var(--wpp-grey-color-200));--fu-bg-color-disabled:var(--wpp-file-upload-bg-color-disabled, var(--wpp-grey-color-200));--fu-border-color:var(--wpp-file-upload-border-color, var(--wpp-grey-color-500));--fu-border-color-hover:var(--wpp-file-upload-border-color-hover, var(--wpp-grey-color-600));--fu-border-style:var(--wpp-file-upload-border-style, dashed);--fu-border-error-style:var(--wpp-file-upload-border-error-style, solid);--fu-border-error-color:var(--wpp-file-upload-border-error-color, var(--wpp-danger-color-500));--fu-border-width:var(--wpp-file-upload-border-width, 1px);--fu-border-radius:var(--wpp-file-upload-border-radius, var(--wpp-border-radius-m));--fu-first-border-color-focus:var(--wpp-file-upload-first-border-color-focus, var(--wpp-grey-color-000));--fu-second-border-color-focus:var(--wpp-file-upload-second-border-color-focus, var(--wpp-brand-color));--fu-text-info-color:var(--wpp-file-upload-text-info-color, var(--wpp-text-color-info));--fu-text-info-margin:var(--wpp-file-upload-text-info-margin, 4px 0 0 0);--fu-text-color:var(--wpp-file-upload-text-color, var(--wpp-grey-color-900));--fu-text-color-disabled:var(--wpp-file-upload-text-color-disabled, var(--wpp-text-color-disabled));--fu-label-color-hover:var(--wpp-file-upload-label-color-hover, var(--wpp-primary-color-400));--fu-label-color-active:var(--wpp-file-upload-label-color-active, var(--wpp-primary-color-600));--fu-icon-margin:var(--wpp-file-upload-icon-margin, 0 0 16px 0);--fu-icon-color-disabled:var(--wpp-file-upload-icon-color-disabled, var(--wpp-icon-color-disabled));--fu-item-max-width:var(--wpp-file-upload-item-max-width, 100%);--fu-item-gradient:var(--wpp-file-upload-item-gradient, linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.75) 100%));--fu-item-gradient-height:var(--wpp-file-upload-item-gradient-height, 32px);outline:none}:host([disabled]:not([disabled=false])){cursor:not-allowed}.upload-wrapper{position:relative;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;width:var(--fu-width);height:var(--fu-height);border:var(--fu-border-width) var(--fu-border-style) var(--fu-border-color);border-radius:var(--fu-border-radius);background-color:var(--fu-bg-color);-webkit-transition:0.2s ease-in-out;transition:0.2s ease-in-out}.upload-wrapper.tab-focus{border-radius:var(--fu-border-radius);outline:none;-webkit-box-shadow:0 0 0 1px var(--fu-first-border-color-focus), 0 0 0 3px var(--fu-second-border-color-focus);box-shadow:0 0 0 1px var(--fu-first-border-color-focus), 0 0 0 3px var(--fu-second-border-color-focus)}.upload-wrapper:hover{background-color:var(--fu-bg-color-hover);border-color:var(--fu-border-color-hover)}.upload-wrapper.message{margin-bottom:8px}.upload-wrapper.error{border:var(--fu-border-width) var(--fu-border-error-style) var(--fu-border-error-color)}.upload-wrapper.error.tab-focus{border-radius:\"\";outline:none;-webkit-box-shadow:0 0 0 1px var(--fu-first-border-color-focus), 0 0 0 3px var(--fu-border-error-color);box-shadow:0 0 0 1px var(--fu-first-border-color-focus), 0 0 0 3px var(--fu-border-error-color)}.upload-wrapper.disabled{pointer-events:none;background-color:var(--fu-bg-color-disabled);border:none}.upload-wrapper.disabled .icon-file{color:var(--fu-icon-color-disabled)}.upload-wrapper.disabled .label{color:var(--fu-text-color-disabled);text-decoration:none}.upload-wrapper.disabled .text{color:var(--fu-text-color-disabled)}.upload-wrapper.disabled .text-info{color:var(--fu-text-color-disabled)}.upload-wrapper.file-drag{background-color:var(--fu-bg-color-hover)}.upload-wrapper.file-drag:not(.error){border-color:var(--fu-border-color-hover)}.label{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal);color:var(--wpp-brand-color);text-decoration:underline}.label:hover{color:var(--fu-label-color-hover)}.label:active{color:var(--fu-label-color-active)}.text{font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-body-font-weight, 400);font-style:var(--wpp-typography-s-body-font-style, normal);color:var(--fu-text-color)}.content{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;white-space:break-spaces}.file-loader{width:100%;height:100%;position:absolute;cursor:pointer;opacity:0}.file-list{scrollbar-width:thin;scrollbar-color:var(--wpp-grey-color-400) transparent;width:var(--fu-item-max-width);max-height:400px;overflow-x:hidden;overflow-y:auto;margin:0;padding:0}.file-list::-webkit-scrollbar{width:8px;height:8px}.file-list::-webkit-scrollbar-thumb{border:2px solid transparent;border-radius:4px;-webkit-box-shadow:inset 0 0 0 2px var(--wpp-grey-color-400);box-shadow:inset 0 0 0 2px var(--wpp-grey-color-400)}.file-list-wrapper{position:relative}.file-list-wrapper::before{content:\"\";position:absolute;left:0;right:0;height:var(--fu-item-gradient-height);top:0;z-index:1;pointer-events:none;-webkit-transition:0.3s ease-in-out;transition:0.3s ease-in-out;background:var(--fu-item-gradient);opacity:0;-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.file-list-wrapper::after{content:\"\";position:absolute;left:0;right:0;height:var(--fu-item-gradient-height);bottom:0;z-index:1;pointer-events:none;-webkit-transition:0.3s ease-in-out;transition:0.3s ease-in-out;background:var(--fu-item-gradient);opacity:0}.file-list-wrapper.scroll::before{opacity:1}.file-list-wrapper.scroll::after{opacity:1}.text-info{font-size:var(--wpp-typography-xs-body-font-size, 12px);font-family:var(--wpp-typography-xs-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-xs-body-line-height, 20px);letter-spacing:var(--wpp-typography-xs-body-letter-spacing, 0);text-transform:var(--wpp-typography-xs-body-text-transform, initial);color:var(--wpp-typography-xs-body-color, var(--wpp-text-color));font-weight:var(--wpp-typography-xs-body-font-weight, 400);font-style:var(--wpp-typography-xs-body-font-style, normal);color:var(--fu-text-info-color);margin:var(--fu-text-info-margin)}.icon-file{margin:var(--fu-icon-margin)}::slotted([slot=label]){font-size:var(--wpp-typography-m-body-font-size, 16px);font-family:var(--wpp-typography-m-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-m-body-line-height, 24px);letter-spacing:var(--wpp-typography-m-body-letter-spacing, 0);text-transform:var(--wpp-typography-m-body-text-transform, initial);color:var(--wpp-typography-m-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-m-strong-font-weight, 600);font-style:var(--wpp-typography-m-strong-font-style, normal)}::slotted([slot=description]){font-size:var(--wpp-typography-s-body-font-size, 14px);font-family:var(--wpp-typography-s-body-font-family, var(--wpp-font-family));line-height:var(--wpp-typography-s-body-line-height, 22px);letter-spacing:var(--wpp-typography-s-body-letter-spacing, 0);text-transform:var(--wpp-typography-s-body-text-transform, initial);color:var(--wpp-typography-s-strong-color, var(--wpp-text-color));font-weight:var(--wpp-typography-s-strong-font-weight, 600);font-style:var(--wpp-typography-s-strong-font-style, normal)}@-moz-document url-prefix(){.file-list{padding-right:10px}}";

const getInitFocusInfo = () => ({
  wrapper: FOCUS_TYPE.NONE,
  item: FOCUS_TYPE.NONE,
});
const WppFileUpload$1 = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.wppChange = createEvent(this, "wppChange", 1);
    this.wppFocus = createEvent(this, "wppFocus", 1);
    this.wppBlur = createEvent(this, "wppBlur", 1);
    this.wppFileUploadItemDelete = createEvent(this, "wppFileUploadItemDelete", 1);
    this.wppFileUploadItemClick = createEvent(this, "wppFileUploadItemClick", 1);
    this.reInitValue = (list) => {
      this.successList = list.filter(file => !this.isFileWithError(file));
      this.errorList = list.filter(this.isFileWithError);
    };
    this.onFocus = (event) => {
      this.wppFocus.emit(event);
    };
    this.onBlur = (event) => {
      this.focusType = this.getUpdatedFocusInfo('wrapper', FOCUS_TYPE.NONE);
      this.focusType = this.getUpdatedFocusInfo('item', FOCUS_TYPE.NONE);
      this.wppBlur.emit(event);
    };
    this.onMouseDown = () => {
      this.focusType = this.getUpdatedFocusInfo('wrapper', FOCUS_TYPE.MOUSE);
      this.focusType = this.getUpdatedFocusInfo('item', FOCUS_TYPE.MOUSE);
    };
    this.onKeyUp = (event, type) => {
      if (event.key === 'Tab') {
        this.focusType = this.getUpdatedFocusInfo(type, FOCUS_TYPE.TAB);
      }
    };
    this.getUpdatedFocusInfo = (type, updateValue) => ({
      ...this.focusType,
      [type]: updateValue,
    });
    this.handleDeleteItem = (event) => {
      const updatedFilesList = [...this.successList, ...this.errorList].filter(({ name, size }) => name + size !== event.detail.name + event.detail.size);
      const successList = updatedFilesList.filter(file => !this.isFileWithError(file));
      const errorFileList = updatedFilesList.filter(this.isFileWithError);
      if (this.inputRef?.value) {
        this.inputRef.value = '';
      }
      this.wppChange.emit({
        value: successList,
        hasError: !!errorFileList.length,
        errorFiles: errorFileList,
      });
      this.wppFileUploadItemDelete.emit(event.detail);
      this.value = updatedFilesList;
      this.errorList = errorFileList;
      this.successList = successList;
    };
    this.handleClickItem = (event) => this.wppFileUploadItemClick.emit(event.detail);
    this.validateFileSize = (file) => {
      if (file.size > convertMBToBytes(this.size)) {
        file.sizeError = true;
      }
      return file;
    };
    this.customValidation = (file) => {
      const validationResult = this.validator(file);
      if (validationResult) {
        file.validatorError = validationResult;
      }
      return file;
    };
    this.isAcceptConfigFilled = () => Object.keys(this.acceptConfig).length > 0;
    this.validateFileType = (file) => {
      if (this.isAcceptConfigFilled()) {
        let allowedExtensions = [];
        if (file.type) {
          allowedExtensions = this.acceptConfig[file.type] || [];
        }
        else {
          allowedExtensions = this.getAcceptExtensions();
        }
        if (allowedExtensions.length) {
          const fileExtension = getExtension(file.name);
          file.formatError = !allowedExtensions.includes(fileExtension);
        }
        else {
          file.formatError = true;
        }
        return file;
      }
      if (!this.accept.length) {
        if (file.type.length === 0) {
          const typeFromExtension = EXTENSION_TO_TYPE[file.name.split('.')[1]];
          const modifiedFile = modifyPropertiesOnFile(file, { type: typeFromExtension });
          return modifiedFile;
        }
        return file;
      }
      const isPassValidation = this.accept.some((format) => {
        const currentFormat = format.replace(/[,.*]/g, '');
        // .mov format return quicktime type, that's why using this contraction for this particular case
        if (currentFormat === 'mov') {
          return file.type.includes('quicktime');
        }
        if (/txt|text|msword|document|doc?x/.test(currentFormat)) {
          return /text|application/.test(file.type);
        }
        return file.type.includes(currentFormat);
      });
      if (!isPassValidation) {
        file.formatError = true;
      }
      return file;
    };
    this.isFileWithError = (file) => !!(file.formatError || file.sizeError || file.validatorError);
    this.generateUniqueName = (fileName, fileList) => {
      const baseName = getBaseName(fileName);
      const extension = getExtension(fileName);
      let counter = 1;
      const generateNewName = () => `${baseName}-${counter}${extension}`;
      const isNameTaken = (name) => fileList.some(item => item.name === name);
      let uniqueName = generateNewName();
      while (isNameTaken(uniqueName)) {
        counter++;
        uniqueName = generateNewName();
      }
      return uniqueName;
    };
    this.displayErrorListByShowingOption = (newFilesWithErrors) => this.showOnlyNewErrors ? newFilesWithErrors : [...this.errorList, ...newFilesWithErrors];
    this.handleFileLoad = async (filesList) => {
      const list = [...(this.successList || []), ...(this.errorList || [])];
      const filteredFileList = filesList.filter(Boolean).map(newFile => {
        const isFileWithSameNameExists = !!list.find(item => item.name === newFile.name);
        if (!isFileWithSameNameExists)
          return newFile;
        const uniqueName = this.generateUniqueName(newFile.name, list);
        return renameFile(newFile, uniqueName);
      });
      if (this.isMaximumFilesSet()) {
        filteredFileList.length = this.multiple
          ? Math.min(filteredFileList.length, Math.max(0, this.maxFiles - list.length))
          : 1;
      }
      if (!filteredFileList.length)
        return;
      const validatedFileList = filteredFileList.map((file) => {
        if ('url' in file) {
          return file;
        }
        this.validateFileSize(file);
        file = this.validateFileType(file);
        this.customValidation(file);
        return file;
      });
      if (!this.multiple && this.value.length) {
        this.value = validatedFileList.some(this.isFileWithError) ? this.value : filteredFileList;
      }
      else {
        this.value = [...(this.successList || []), ...(this.errorList || []), ...validatedFileList];
      }
      const successFileList = this.value.filter(file => !this.isFileWithError(file));
      const newFilesWithErrors = validatedFileList.filter((fileItem) => this.isFileWithError(fileItem));
      const errorFileList = this.displayErrorListByShowingOption(newFilesWithErrors);
      this.errorList = errorFileList;
      this.successList = successFileList;
      this.wppChange.emit({
        value: successFileList,
        hasError: !!errorFileList.length,
        errorFiles: errorFileList,
      });
    };
    this.handleDrop = (event) => {
      event.preventDefault();
      const currentFiles = event?.dataTransfer?.files || [];
      this.isFileDrag = false;
      if (!this.multiple && this.value.length) {
        return this.handleFileLoad([currentFiles[0]]);
      }
      if (!this.multiple && currentFiles.length > 1) {
        return this.handleFileLoad([currentFiles[0]]);
      }
      this.handleFileLoad(Array.from(currentFiles));
    };
    this.handleDragOver = (event) => {
      event.preventDefault();
    };
    this.handleDragEnter = () => {
      this.isFileDrag = true;
    };
    this.handleDragLeave = () => {
      this.isFileDrag = false;
    };
    this.handleChange = async () => {
      const currentFiles = this.inputRef?.files || [];
      if (!this.multiple && this.value.length) {
        return this.handleFileLoad([currentFiles[0]]);
      }
      await this.handleFileLoad(Array.from(currentFiles));
      if (this.inputRef?.value) {
        this.inputRef.value = '';
      }
    };
    this.handleListScroll = (event) => {
      const target = event.target;
      if (target.scrollTop && target.scrollHeight - target.scrollTop !== target.clientHeight) {
        this.scrollState = ScrollState.scroll;
        return;
      }
      this.scrollState = false;
    };
    this.getAcceptExtensions = () => {
      if (this.isAcceptConfigFilled()) {
        return getExtensionsList(this.acceptConfig);
      }
      return this.accept;
    };
    this.isMaximumFilesSet = () => this.maxFiles > 0;
    this.isMaximumFilesReached = () => {
      if (!this.multiple) {
        return this.value.length >= 1;
      }
      if (this.isMaximumFilesSet()) {
        return this.value.length >= this.maxFiles;
      }
      return false;
    };
    this.uploadWrapperCssClasses = () => ({
      'upload-wrapper': true,
      message: !!this.message,
      [`${this.messageType}`]: !!this.messageType,
      'tab-focus': this.focusType.wrapper === FOCUS_TYPE.TAB && this.focusType.item !== FOCUS_TYPE.TAB,
      disabled: this.disabled || this.isMaximumFilesReached(),
      'file-drag': this.isFileDrag,
    });
    this.listWrapperCssClasses = () => ({
      'file-list-wrapper': true,
      [`${this.scrollState}`]: !!this.scrollState,
    });
    this.hostCssClasses = () => ({
      'wpp-file-upload': true,
      'file-upload': true,
    });
    this.scrollState = false;
    this.focusType = getInitFocusInfo();
    this.isFileDrag = false;
    this.errorList = undefined;
    this.successList = undefined;
    this.name = undefined;
    this.value = [];
    this.disabled = false;
    this.multiple = true;
    this.format = 'base64';
    this.accept = ['.jpg', '.jpeg', '.png'];
    this.acceptConfig = {};
    this.messageType = undefined;
    this.message = undefined;
    this.maxMessageLength = undefined;
    this.tooltipConfig = {};
    this.size = 50;
    this.maxLabelLength = 30;
    this.locales = {
      label: 'Choose a file',
      text: 'to upload or drag it here',
      info: (accept, size) => `Only ${accept} file at ${size} MB or less`,
      sizeError: 'File exceeds size limit',
      formatError: 'Wrong format',
    };
    this.validator = () => null;
    this.controlled = false;
    this.maxFiles = 0;
    this.showOnlyNewErrors = false;
  }
  /**
   * Method to reset FileUpload
   */
  async reset() {
    this.successList = [];
    this.errorList = [];
  }
  onValueChange(newValue) {
    if (this.controlled) {
      this.reInitValue(newValue);
    }
  }
  componentDidLoad() {
    const list = [...this.value, ...(this.successList || []), ...(this.errorList || [])];
    this.reInitValue(list);
  }
  render() {
    const allFiles = [...(this.successList || []), ...(this.errorList || [])];
    return (h(Host, { class: this.hostCssClasses(), exportparts: "file-item, wrapper, content, file-name, tooltip, loading, percentage, cross-icon", onFocus: this.onFocus, onBlur: this.onBlur, onMouseDown: this.onMouseDown, onKeyUp: (event) => this.onKeyUp(event, 'wrapper') }, h("slot", { name: "label", part: "slot-label" }), h("slot", { name: "description", part: "slot-description" }), h("div", { class: this.uploadWrapperCssClasses(), onDrop: this.handleDrop, onDragEnter: this.handleDragEnter, onDragLeave: this.handleDragLeave, onDragOver: this.handleDragOver, part: "file-upload-container" }, h("wpp-icon-file-v2-9-0", { class: "icon-file", part: "icon-file" }), h("div", { class: "content", part: "content" }, h("span", { class: "label", part: "label" }, this.locales.label), h("span", { class: "text", part: "text" }, ' ', this.locales.text)), h("p", { class: "text-info", part: "text-info" }, this.locales.info(this.getAcceptExtensions().join(', '), this.size)), h("input", { class: "file-loader", type: "file", name: this.name, onChange: this.handleChange, ref: inputRef => (this.inputRef = inputRef), multiple: this.multiple, accept: this.getAcceptExtensions().join(), part: "input", title: "" })), this.message && (h("wpp-inline-message-v2-9-0", { message: this.message, type: this.messageType, showTooltipFrom: this.maxMessageLength, tooltipConfig: this.tooltipConfig, part: "message" })), allFiles.length ? (h("div", { class: this.listWrapperCssClasses(), part: "list-wrapper" }, h("ul", { class: "file-list", part: "file-list", onScroll: this.handleListScroll }, allFiles.map((file, index) => (h("wpp-file-upload-item-v2-9-0", { key: file.lastModified, format: this.format, maxLabelLength: this.maxLabelLength, currentIndex: index, onWppDelete: this.handleDeleteItem, onWppClick: this.handleClickItem, file: file, tabIndex: 0, locales: {
        sizeError: this.locales.sizeError,
        formatError: this.locales.formatError,
      }, part: "file-item", onBlur: this.onBlur, onKeyUp: (event) => this.onKeyUp(event, 'item') })))))) : null));
  }
  static get registryIs() { return "wpp-file-upload-v2-9-0"; }
  get host() { return this; }
  static get watchers() { return {
    "value": ["onValueChange"]
  }; }
  static get style() { return wppFileUploadCss; }
}, [1, "wpp-file-upload", "wpp-file-upload-v2-9-0", {
    "name": [1],
    "value": [1040],
    "disabled": [516],
    "multiple": [4],
    "format": [1],
    "accept": [16],
    "acceptConfig": [16],
    "messageType": [1, "message-type"],
    "message": [1],
    "maxMessageLength": [2, "max-message-length"],
    "tooltipConfig": [1040],
    "size": [2],
    "maxLabelLength": [2, "max-label-length"],
    "locales": [16],
    "validator": [16],
    "controlled": [4],
    "maxFiles": [2, "max-files"],
    "showOnlyNewErrors": [4, "show-only-new-errors"],
    "scrollState": [32],
    "focusType": [32],
    "isFileDrag": [32],
    "errorList": [32],
    "successList": [32],
    "reset": [64]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-file-upload-v2-9-0", "wpp-file-upload-item-v2-9-0", "wpp-icon-cross-v2-9-0", "wpp-icon-database-v2-9-0", "wpp-icon-document-v2-9-0", "wpp-icon-error-v2-9-0", "wpp-icon-file-v2-9-0", "wpp-icon-file-zip-v2-9-0", "wpp-icon-image-v2-9-0", "wpp-icon-info-v2-9-0", "wpp-icon-music-v2-9-0", "wpp-icon-pitch-v2-9-0", "wpp-icon-spreadsheet-v2-9-0", "wpp-icon-success-v2-9-0", "wpp-icon-video-clip-v2-9-0", "wpp-icon-warning-v2-9-0", "wpp-inline-message-v2-9-0", "wpp-internal-tooltip-v2-9-0", "wpp-spinner-v2-9-0", "wpp-tooltip-v2-9-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-file-upload-v2-9-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppFileUpload$1);
      }
      break;
    case "wpp-file-upload-item-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$k();
      }
      break;
    case "wpp-icon-cross-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$j();
      }
      break;
    case "wpp-icon-database-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$i();
      }
      break;
    case "wpp-icon-document-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$h();
      }
      break;
    case "wpp-icon-error-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$g();
      }
      break;
    case "wpp-icon-file-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$f();
      }
      break;
    case "wpp-icon-file-zip-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$e();
      }
      break;
    case "wpp-icon-image-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$d();
      }
      break;
    case "wpp-icon-info-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$c();
      }
      break;
    case "wpp-icon-music-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$b();
      }
      break;
    case "wpp-icon-pitch-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$a();
      }
      break;
    case "wpp-icon-spreadsheet-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$9();
      }
      break;
    case "wpp-icon-success-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$8();
      }
      break;
    case "wpp-icon-video-clip-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$7();
      }
      break;
    case "wpp-icon-warning-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$6();
      }
      break;
    case "wpp-inline-message-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$5();
      }
      break;
    case "wpp-internal-tooltip-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$4();
      }
      break;
    case "wpp-spinner-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$3();
      }
      break;
    case "wpp-tooltip-v2-9-0":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}
defineCustomElement$1();

const WppFileUpload = WppFileUpload$1;
const defineCustomElement = defineCustomElement$1;

export { ScrollState as S, WppFileUpload, defineCustomElement };
